import React from "react";
import { useSelector } from 'react-redux';
import { selectCurrentTrip } from '../../../store/tripsSlice';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as ItinerarywhiteIcon} from '../../../assets/Itinerarywhite-icon.svg';
import { ReactComponent as HomeIcon } from '../../../assets/home-icon.svg';
import './ItineraryNav.css'; 

const ItineraryNav = () => {
    const location = useLocation();

    const trip = useSelector(selectCurrentTrip);
    console.log("Current Trip in ItineraryNav:", trip);

    if (!trip) return <div>No Trip Selected</div>; 


    const dailyPlans = trip ? trip.daily_plans : [];

    const isItineraryPage = location.pathname.startsWith("/planner/");

     console.log("Daily Plans:", dailyPlans);

    return (
        <nav className="itinerary-nav">
            <h1>{trip ? trip.trip_name : "No Trip Selected"}</h1>
            <ul>
                <li className="homenav-header">
                    <Link to="/" className={location.pathname === "/"? "nav-link active" : "nav-link"}>
                    <HomeIcon className = "homenav-icon"/>
                    Home</Link>
                </li>  
                <li className="itinerarynav-header">
                    <Link
                    to={`/planner/${trip.TRIP_ID}`}
                    className={isItineraryPage ? "nav-link active" : "nav-link"}
                    >
                         <ItinerarywhiteIcon className = "itinerynav-icon"/>
                        Itinerary
                    </Link>
                </li>
              {dailyPlans.length > 0 ? (
              dailyPlans.map((day, index) => (
                <li key={day.daily_plan_id}>
                    <button
                    className="day-link"
                    onClick={() => document.getElementById(`day-${index + 1}`).scrollIntoView({ behavior: "smooth", block: "start"})}
                    >
                        {`${day.name}: ${new Date(day.date).toLocaleDateString()}`}
                        </button>
                </li>
                
                ))
              ) : (
                <li>No Daily Plans Available</li>
              )}
              
            </ul>
           </nav> 
    );
};

export default ItineraryNav;
